<template>
	<div class="toggle" :class="{ simple }" ref="toggle">
		<div class="toggle-values-wrapper">
			<div
				v-for="item in values"
				@click="$emit('update:modelValue', item.value)"
				:key="item.value"
				class="toggle-val"
				:data-value="item.value"
				:class="{ active: item.value === modelValue }"
			>
				<div v-show="!simple" class="toggle-val-label">{{ item.label }}</div>
			</div>
		</div>
		<div class="toggle-caret" ref="caret" :style="caretStyles"></div>
	</div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref, watch } from '@vue/runtime-core'
import { nextTick, toRef } from 'vue'

// eslint-disable-next-line no-undef
const props = defineProps({
	modelValue: {
		type: [String, Number]
	},
	values: {
		type: Array,
		default: () => []
	},
	simple: {
		type: Boolean,
		default: false
	}
})

const caretStyles = ref(null)

const value = toRef(props, 'modelValue')

// eslint-disable-next-line no-undef
defineEmits(['update:modelValue'])

const caret = ref(null)
const toggle = ref(null)

onMounted(() => {
	addResizeHandler()
	styleCaret(true)
	watch(value, () => {
		nextTick(styleCaret)
	})
})

onBeforeUnmount(() => {
	removeResizeHandler()
})

function styleCaret(instantly = false) {
	const activeItem = toggle.value.querySelector('.active')
	const toggleLeft = toggle.value.getBoundingClientRect().left
	const activeBCR = activeItem.getBoundingClientRect()
	caretStyles.value = `width: ${activeBCR.width - 2}px; transform: translateX(${activeBCR.left - toggleLeft + 1}px); ${
		instantly ? 'transition: none' : ''
	}`
}

function addResizeHandler() {
	window.addEventListener('resize', resizeHandler)
}

function removeResizeHandler() {
	window.removeEventListener('resize', resizeHandler)
}

function resizeHandler() {
	styleCaret(true)
}
</script>

<style scoped lang="scss">
.toggle {
	width: 100%;
	position: relative;
	font-size: 1.14285rem;

	&-values-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	&-val {
		font-weight: 600;
		padding: 4px 10px;
		background: #e2e3ee;
		transition: color 500ms;
		cursor: pointer;
		min-width: 90px;
		text-align: center;

		&:first-child {
			border-top-left-radius: 7px;
			border-bottom-left-radius: 7px;
		}

		&:last-child {
			border-top-right-radius: 7px;
			border-bottom-right-radius: 7px;
		}

		&-label {
			position: relative;
			z-index: 2;
		}

		&.active {
			color: #fff;
		}
	}

	&-caret {
		position: absolute;
		z-index: 1;
		top: 1px;
		left: 0;
		height: calc(100% - 2px);
		width: 100px;
		background: #7d8bf7;
		border-radius: 7px;
		transition: width 500ms ease, transform 500ms ease;
	}
}
</style>
